export default "__VITE_ASSET__CaOe6rqQ__"